import React, { useEffect, useState } from 'react';
import './footerBar.css';
import api from '../../services/api';
import { vhostV1, vhostV2 } from '../funcoes';
import { Box, Container, Typography } from '@mui/material';

function FooterBar() {

    const [empresa, setEmpresa] = useState([]);
    const [sResult, setSresult] = useState(0);
    const loja = localStorage.getItem('loja');
    

    let config = {
        headers: {
          'Authorization': localStorage.getItem("token")
        }
      }

      let config2 = {
        headers: {
          'Authorization': localStorage.getItem("token2")
        }
      }  

     useEffect(function(){
        
              api.post(vhostV1('webcash/Empresa/retornaEmpresa'),{},config)
                .then(function (response) {           
                  console.log(response);
                  setEmpresa(response.data.dados);
                  
                  
                                              
                           
                })
                .catch(function (error) {
                 
                  console.log(error);
        
                          
                });
          
                
              },[])

        const razaoSocial = empresa?.RAZAO_SOCIAL;

   
    

  return(
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        zIndex: 1000,
        backgroundColor: '#333333',
        color: 'white',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: '2px',
        height: 'auto',
      }}
    >
      <Typography
        id="pFooter"
        sx={{
          marginTop: '6px',
          fontSize: '12px',
        }}
      >
        © 2024, {razaoSocial}, Loja {loja}. Todos os direitos reservados.
      </Typography>
    </Box>
  );
}

export default FooterBar;